/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {approveCashAppPay} from '../api'

export const useMutationApproveCashAppPay = createReactQueryMutationHook('approveCashAppPay', approveCashAppPay)
